/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { IExample } from '../../core/models/common/IExample';
import { IExamplesParent } from '../../core/models/common/IExamplesParent';
import { MarshallCompat } from '../../compat/MarshallCompat';

/**
 * A command used to delete a single mediaType from an operation.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteAllExamplesCommand extends AbstractCommand {
    public _mediaTypePath : NodePath;

    public _oldExamples : any;

    public constructor(parent? : any) {
        if(((parent != null && (parent["__interfaces"] != null && parent["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.IExamplesParent") >= 0 || parent.constructor != null && parent.constructor["__interfaces"] != null && parent.constructor["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.IExamplesParent") >= 0)) || parent === null)) {
            let __args = arguments;
            super();
            if(this._mediaTypePath===undefined) this._mediaTypePath = null;
            if(this._oldExamples===undefined) this._oldExamples = null;
            if(this._mediaTypePath===undefined) this._mediaTypePath = null;
            if(this._oldExamples===undefined) this._oldExamples = null;
            (() => {
                this._mediaTypePath = Library.createNodePath(<Node><any>parent);
            })();
        } else if(parent === undefined) {
            let __args = arguments;
            super();
            if(this._mediaTypePath===undefined) this._mediaTypePath = null;
            if(this._oldExamples===undefined) this._oldExamples = null;
            if(this._mediaTypePath===undefined) this._mediaTypePath = null;
            if(this._oldExamples===undefined) this._oldExamples = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteAllExamplesCommand] Executing.");
        if(this.isNullOrUndefined(document)) {
            LoggerCompat.debug("[DeleteAllExamplesCommand] Could not execute the command, invalid argument.");
            return;
        }
        if(this.isNullOrUndefined(this._mediaTypePath)) {
            LoggerCompat.debug("[DeleteAllExamplesCommand] Could not execute the command, problem when unmarshalling.");
            return;
        }
        let parent : IExamplesParent = <IExamplesParent><any>this._mediaTypePath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            LoggerCompat.debug("[DeleteAllExamplesCommand] Media type not found.");
            return;
        }
        this._oldExamples = <any>({});
        parent.getExamples().forEach((e) => {
            /* put */(this._oldExamples[e.getName()] = Library.writeNode(<Node><any>e));
        });
        parent.clearExamples();
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        if(this.isNullOrUndefined(document)) {
            LoggerCompat.debug("[DeleteAllExamplesCommand] Could not revert the command, invalid argument.");
            return;
        }
        if(this.isNullOrUndefined(this._mediaTypePath)) {
            LoggerCompat.debug("[DeleteAllExamplesCommand] Could not revert the command, problem when unmarshalling.");
            return;
        }
        LoggerCompat.info("[DeleteAllExamplesCommand] Reverting.");
        let parent : IExamplesParent = <IExamplesParent><any>this._mediaTypePath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            LoggerCompat.info("[DeleteAllExamplesCommand] No media type found.");
            return;
        }
        if(this.isNullOrUndefined(this._oldExamples)) {
            LoggerCompat.info("[DeleteAllExamplesCommand] Could not revert. Previous data is not available.");
            return;
        }
        {
            let array140 = /* keySet */Object.keys(this._oldExamples);
            for(let index139=0; index139 < array140.length; index139++) {
                let k = array140[index139];
                {
                    let example : IExample = parent.createExample(k);
                    Library.readNode(/* get */((m,k) => m[k]===undefined?null:m[k])(this._oldExamples, k), <Node><any>example);
                    parent.addExample(example);
                }
            }
        }
    }
}
DeleteAllExamplesCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteAllExamplesCommand";
DeleteAllExamplesCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




